import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import QuantService from '../../../service/quant/Quant';

interface Props {
  onClose: () => void;
  selectedIdx: number | null;
  mode: string;
  getQuantList: () => void;
}

interface groupProps {
  group: string;
  group_idx: number;
}

function AddInterestReportModal({
  onClose,
  selectedIdx,
  mode,
  getQuantList,
}: Props) {
  const [groupList, setGroupList] = useState<groupProps[]>([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [addCategory, setAddCategory] = useState(false);
  const [groupName, setGroupName] = useState('');
  const [editGroupIdx, setEditGroupIdx] = useState<number | null>(null);
  const [editGroupName, setEditGroupName] = useState<string>('');
  const [selectedGroup, setSelectedGroup] = useState<string>('미분류');
  const [seletedGroupIdx, setSelectedGroupIdx] = useState<number>(-1);
  const [memo, setMemo] = useState<string>('');

  const getGroupList = async () => {
    try {
      const res = await QuantService.groupList();
      setGroupList(res.data);
    } catch (err) {
      console.log(err, '발생');
    }
  };

  useEffect(() => {
    getGroupList();
  }, []);

  const addGroup = async () => {
    try {
      const data = {
        group: groupName,
      };
      await QuantService.registerGroup(data);
      getGroupList();
      setGroupName('');
      setAddCategory(false);
    } catch (err) {
      console.log(err, '발생');
    }
  };

  const updateGroup = async (idx: number) => {
    const data = {
      group: editGroupName,
    };
    try {
      await QuantService.updateGroup(idx, data);
      setEditGroupIdx(null);
      getGroupList();
      setEditGroupName('');
    } catch (error) {
      console.error('updateGroup 함수에서 에러 발생:', error);
    }
  };

  const deleteGroup = async (group_idx: number) => {
    try {
      await QuantService.deleteGroup(group_idx);
      getGroupList();
    } catch (error) {
      console.error('deleteGroup 함수에서 에러 발생:', error);
    }
  };

  const add = async () => {
    const data = {
      quantIdx: selectedIdx,
      groupIdx: seletedGroupIdx,
      memo: memo,
    };
    try {
      await QuantService.addInterest(data);
      onClose();
      getQuantList();
    } catch (error) {
      console.error('add 함수에서 에러 발생:', error);
    }
  };

  const handleEditClick = (group_idx: number, group: string) => {
    setEditGroupIdx(group_idx);
    setEditGroupName(group);
  };

  const handleGroupChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEditGroupName(e.target.value);
  };

  const handleDelete = (group_idx: number) => {
    window.confirm('정말 삭제하시겠습니까?') && deleteGroup(group_idx);
    // getGroupList();
  };

  const updataItem = async () => {
    if (selectedIdx === null) return;

    const data = {
      memo: memo,
      groupIdx: seletedGroupIdx,
    };
    try {
      await QuantService.updateInterest(selectedIdx, data);
      getQuantList();
    } catch (error) {
      console.error('updateItem 함수에서 에러 발생:', error);
    }
  };

  const handleAddInterestItem = () => {
    if (mode === 'edit') {
      updataItem(); // 관심 리포트 수정 API 호출
    } else {
      add(); // 관심 리포트 추가 API 호출
    }
    onClose();
  };

  const renderGroupList = () => {
    if (isEditMode) {
      return (
        <>
          {groupList.map((item, index) => (
            <CategoryItem key={index}>
              <CategoryItemRow>
                <img src="/assets/images/icon/star-in-circle.svg" alt="" />
                {editGroupIdx === item.group_idx ? (
                  <MemoInput
                    type="text"
                    value={editGroupName}
                    onChange={handleGroupChange}
                  />
                ) : (
                  <span>{item.group}</span>
                )}
              </CategoryItemRow>
              {item.group === '미분류' ? null : (
                <>
                  {editGroupIdx === item.group_idx ? (
                    <CategoryItemButtonBox>
                      <CategoryItemDeleteButton
                        onClick={() => {
                          setEditGroupIdx(null);
                          setEditGroupName('');
                        }}
                      >
                        취소
                      </CategoryItemDeleteButton>
                      <CategoryItemEditButton
                        onClick={() => updateGroup(item.group_idx)}
                      >
                        변경
                      </CategoryItemEditButton>
                    </CategoryItemButtonBox>
                  ) : (
                    <CategoryItemButtonBox>
                      <CategoryItemDeleteButton
                        onClick={() => {
                          handleDelete(item.group_idx);
                        }}
                      >
                        삭제
                      </CategoryItemDeleteButton>
                      <CategoryItemEditButton
                        onClick={() =>
                          handleEditClick(item.group_idx, item.group)
                        }
                      >
                        수정
                      </CategoryItemEditButton>
                    </CategoryItemButtonBox>
                  )}
                </>
              )}
            </CategoryItem>
          ))}
        </>
      );
    } else {
      return (
        <>
          {groupList.map((item, index) => (
            <CategoryItem
              key={index}
              onClick={() => {
                setSelectedGroup(item.group);
                setSelectedGroupIdx(item.group_idx);
              }}
            >
              <CategoryItemRow>
                <img src="/assets/images/icon/star-in-circle.svg" alt="" />
                <span>{item.group}</span>
              </CategoryItemRow>
              {selectedGroup === item.group && (
                <img src="/assets/images/check/signUpcheckOn.svg" alt="" />
              )}
            </CategoryItem>
          ))}
        </>
      );
    }
  };

  return (
    <ModalOverlay
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClose();
      }}
    >
      <ModalContainer
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <TitleBox>
          <Spacer />
          <Title>관심 리포트 편집</Title>
          <img
            src="/assets/images/close/close-dark-gray.svg"
            alt="닫기"
            width={24}
            onClick={onClose}
          />
        </TitleBox>

        <Content>
          <CategoryMagageButton
            onClick={() => {
              setIsEditMode(!isEditMode);
            }}
            style={{
              backgroundColor: groupList.length > 1 ? '#EAF4FF' : 'f7f7f8',
              color:
                groupList.length > 1 ? '#008AFF' : 'rgba(55, 56, 60, 0.16)',
            }}
          >
            <img
              src={`/assets/images/icon/${groupList.length > 1 ? 'blue-pencil' : 'pencil-gray'}.svg`}
              alt=""
              width={24}
            />
            <span>관심분류 관리</span>
          </CategoryMagageButton>
          <CategoryList>
            <AddCategoryItem
              onClick={() => {
                if (groupList.length >= 10) {
                  alert('관심분류는 최대 10개까지 등록 가능합니다.');
                } else {
                  setAddCategory(!addCategory);
                }
              }}
            >
              <img src="/assets/images/icon/plus-circle.svg" alt="" />
              <span>관심분류 추가</span>
            </AddCategoryItem>
            {addCategory && (
              <AddCategory>
                <MemoInput
                  type="text"
                  placeholder="관심분류명을 입력해주세요."
                  value={groupName}
                  onChange={(e) => {
                    const input = e.target.value;
                    const isKorean = /[가-힣]/.test(input);
                    if (isKorean && input.length <= 10) {
                      setGroupName(input);
                    } else if (!isKorean && input.length <= 20) {
                      setGroupName(input);
                    } else {
                      alert(
                        '관심분류명은 한글 10자, 영문 20자 내로만 등록 가능합니다.',
                      );
                    }
                  }}
                />
                <GuideTextBox>
                  <GuideText>
                    <img src="/assets/images/icon/info-gray.svg" alt="" />
                    <div>
                      관심분류명은 한글 10자, 영문 20자 내로만 등록 가능합니다.
                    </div>
                  </GuideText>
                  <GuideText>
                    <img src="/assets/images/icon/info-gray.svg" alt="" />
                    <div>관심분류는 최대 10개까지 등록 가능합니다.</div>
                  </GuideText>
                </GuideTextBox>
                <AddCategoryButton
                  onClick={() => {
                    addGroup();
                  }}
                >
                  추가
                </AddCategoryButton>
              </AddCategory>
            )}
            {renderGroupList()}
          </CategoryList>
          <MemoInput
            type="text"
            placeholder="(선택) 메모를 입력해주세요."
            value={memo}
            onChange={(e) => {
              setMemo(e.target.value);
            }}
          />
          <ButtonBox>
            <Button onClick={onClose}>취소</Button>
            <Button
              style={{ backgroundColor: '#008AFF', color: '#fff' }}
              onClick={handleAddInterestItem}
            >
              저장
            </Button>
          </ButtonBox>
        </Content>
      </ModalContainer>
    </ModalOverlay>
  );
}

export default AddInterestReportModal;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00000085;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const ModalContainer = styled.div`
  width: 100%;
  background-color: #ffffff;
  overflow: hidden;
  box-shadow: 0px -4px 15px 0px #00000040;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
`;

const TitleBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 16px;

  img {
    cursor: pointer;
  }
`;
const Spacer = styled.div`
  width: 24px;
`;

const Title = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #222222;
`;

const Content = styled.div`
  padding: 0 16px;
`;
const CategoryMagageButton = styled.button`
  width: 100%;
  padding: 9px 16px;
  display: flex;
  flex-direction: row;
  gap: 6px;
  justify-content: center;
  align-items: center;
  background-color: #f7f7f8;
  border-radius: 8px;
  border: none;
  font-size: 16px;
  font-weight: 500;
  color: rgba(55, 56, 60, 0.16);
  cursor: pointer;
`;

const CategoryList = styled.div`
  width: 100%;
  padding: 24px 0;
  display: flex;
  flex-direction: column;
  /* gap: 16px; */
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-weight: 500;
  color: #616161;
`;
const AddCategoryItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(112, 115, 124, 0.16);
  cursor: pointer;
`;
const CategoryItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid rgba(112, 115, 124, 0.16);
  cursor: pointer;
`;
const CategoryItemRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

const MemoInput = styled.input`
  width: 100%;
  height: 50px;
  border-radius: 8px;
  background: #f5f7fa;
  padding: 12px 16px;
  border: none;

  ::placeholder {
    font-family: 'Spoqa Han Sans Neo';
    font-size: 16px;
    font-weight: 500;
    color: #9ea5b599;
  }
`;

const ButtonBox = styled.div`
  width: 100%;
  padding-top: 16px;
  padding-bottom: 40px;
  gap: 24px;

  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const Button = styled.div`
  flex: 1;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background-color: rgba(112, 115, 124, 0.08);
  color: #616161;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
`;
const AddCategory = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-bottom: 1px solid rgba(112, 115, 124, 0.16);
  padding-bottom: 16px;
`;

const GuideTextBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const GuideText = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 6px;
  align-items: center;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-weight: 500;
  color: rgba(55, 56, 60, 0.61);
`;

const AddCategoryButton = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #008aff;
  color: #008aff;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
`;

const CategoryItemButtonBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-weight: 500;
`;
const CategoryItemDeleteButton = styled.span`
  width: 60px;
  height: 40px;
  border-radius: 8px;
  background-color: rgba(112, 115, 124, 0.08);
  display: flex;
  justify-content: center;
  align-items: center;
`;
const CategoryItemEditButton = styled.span`
  width: 60px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #008aff;
  color: #008aff;
  display: flex;
  justify-content: center;
  align-items: center;
`;
